<template>
  <div class="flex">
    <div class="formulate-input-element mr-1">
      <select
        :value="value.protocol"
        @input="updateProtocol"
        class="h-full px-2"
      >
        <option
          v-for="option in options"
          :key="option"
          :value="option"
          v-text="option"
        />
      </select>
    </div>
    <div
      :class="
        `formulate-input-element formulate-input-element--${context.type} flex-1`
      "
      :data-type="context.type"
    >
      <input
        type="text"
        :value="value.url"
        @input="updateUrl"
        v-bind="context.attributes"
      />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    context: Object,
  },
  data() {
    return {
      options: ['http://', 'https://'],
    };
  },
  computed: {
    value() {
      const [protocol, url] = this.context.model.split('://');
      return {
        protocol: protocol ? protocol + '://' : 'https://',
        url: url || '',
      };
    },
  },
  methods: {
    updateProtocol(event) {
      const value = event.target.value;
      this.context.model = value + this.value.url;
    },
    updateUrl(event) {
      const value = event.target.value;
      this.context.model = value + this.value.url;
      if (value.includes('://')) {
        this.context.model = value;
      } else {
        this.context.model = this.value.protocol + value;
      }
    },
  },
};
</script>
